export class UserFacingError extends Error {
    errorCode?: string;
    displayMessage: any;
    status?: number;
    constructor({ message, displayMessage, errorCode, status = 500  }: { message?: string, errorCode?: string, displayMessage: string, status?: number  }){
        super(message || displayMessage);
        this.errorCode = errorCode;
        this.displayMessage = displayMessage;
        this.status = status;
    }
}
